module.exports = __webpack_public_path__ + "img/RegSuccess.8153641f.png";